export const config = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL!,
  awsRegion: process.env.NEXT_PUBLIC_AWS_REGION!,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT!,
  cognitoClientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID!,
  cognitoDomain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN!,
  appUrl: () => window.location.origin,
};
